import React from "react";
import { Link } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="relative z-10 w-full bg-black/40 backdrop-blur-lg border-t border-white/10 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2 text-gray-400">
          <FaGlobe className="text-cyan-500" />
          <span>All Stream Downloader © 2026. All rights reserved.</span>
        </div>
        
        <div className="flex gap-8">
          <Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link>
          <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;